import firebase from 'firebase/app';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBwZGamuSOOSSdfjIZrzAUpa2-slG8I0rs",
    authDomain: "dibs-it-90174.firebaseapp.com",
    databaseURL: "https://dibs-it-90174.firebaseio.com",
    projectId: "dibs-it-90174",
    storageBucket: "dibs-it-90174.appspot.com",
    messagingSenderId: "960037109473",
    appId: "1:960037109473:web:3de0f7034b1cc985a141a0",
    measurementId: "G-RWKW4NT6WY"
  };

  firebase.initializeApp(firebaseConfig);

  const storage = firebase.storage();

  export { storage, firebase as default };


// WEBPACK FOOTER //
// ./src/firebase/index.js